module.exports = __webpack_public_path__ + "img/start.b4cc614.svg";